import { MemberPermissions as GraphQLMemberPermission } from '__generated__/graphql';

/**
 * @deprecated MemberPermission is deprecated, use generated MemberPermissions from `__generated__/graphql`
 */
enum MemberPermission {
  MANAGE_EMPLOYEES = GraphQLMemberPermission.ManageEmployees,
  MANAGE_MEDIA_COLLECTION = GraphQLMemberPermission.ManageMediaCollection,
  MANAGE_SCHEDULE = GraphQLMemberPermission.ManageSchedule,
  MANAGE_TIME_ENTRIES = GraphQLMemberPermission.ManageTimeEntries,
  MANAGE_TIME_OFF = GraphQLMemberPermission.ManageTimeOff,
  MEMBER_LOCK = GraphQLMemberPermission.MemberLock,
  REQUEST_SIGNATURES = GraphQLMemberPermission.RequestSignatures,
  TIME_EVENTS = GraphQLMemberPermission.TimeEvents,
  VIEW_MEMBER_ACTIVITY_REPORT = GraphQLMemberPermission.ViewMemberActivityReport,
  VIEW_SCHEDULE = GraphQLMemberPermission.ViewSchedule,
  CAN_MANAGE_PROJECT_COST_CODE_QUANTITY = GraphQLMemberPermission.CanManageProjectCostCodeQuantity,
  MANAGE_PER_DIEM = GraphQLMemberPermission.ManagePerDiem,
}

export default MemberPermission;
